import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { Benchmark } from '../../../Models/Models/Benchmarks/Benchmark';

declare var IS_RUNNING_IN_APP_POOL;

export class AvailableBenchmarksClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<Array<Benchmark>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioAnalysis/Benchmarks/AvailableBenchmarks/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<Array<Benchmark>, any>(url, data);
  }
}

